import React, { useState } from "react";

const Cards = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = (e) => {
    e.preventDefault();
    setIsExpanded(!isExpanded);
  };
  const fullText = `
To deliver innovative automation solutions, robust end-of-line systems, high-precision test and measurement instruments, and advanced laboratory equipment that empower our clients to achieve operational excellence. We are committed to providing customized, reliable, and cost-effective solutions tailored to the unique needs of each industry we serve. Through our expertise and strong industry partnerships, we strive to advance technological progress, ensure quality, and support customer success with unwavering dedication to excellence.
  `;

  return (
    <div>
      <div class="full_wrapper padtb_100_100">
        <div class="container">
          <div class="row">
            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 prht60">
              <div class="vision_col full_width">
                <h3 class="fnt_white_color margin_0">Our Mission</h3>
                <div className="expandable-text">
                  <p className={`mbot10 ${isExpanded ? "expanded" : ""}`}>
                    {isExpanded
                      ? fullText
                      : `Technociv is a group of engineers who work to bridge 
                                        the gap between humans and machines. We believe that effectively
                                        creating communication between humans and machines is the key to the future..
                                        `}
                  </p>
                  <a
                    href="#"
                    onClick={handleToggle}
                    className="read_more view_more"
                  >
                    {isExpanded ? "Read Less" : "Read More"}
                  </a>
                </div>
                {/* <p class="mbot10">Technociv is a group of engineers who work to bridge the gap between humans and machines. We believe that effectively
                                    creating communication between humans and machines is the key to the future.
                                    Our team aims to high-quality.
                                    low cost and easy to use products that incorporate high technology for the individual.
                                    We work to satisfy the needs of the
                                    customers to the maximum all the while seeing the budget of the clients. We aim to
                                    provide the best possible services at fair and competitive prices.
                                </p><a href="#" class="read_more view_more">Read More </a> */}
              </div>
            </div>
            <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 fr">
              <div class="row vision_pad">
                <div class="col-md-6  ">
                  <div class="row mbot40">
                    <div class="col-lg-3 col-md-4 col-sm-2 col-xs-4">
                      <img
                        src="/img/delicate_team.png"
                        alt="quality assurance"
                      />
                    </div>
                    <div class="col-lg-9 col-md-8 col-sm-10 col-xs-8">
                      <h4 class="letter_space_0 mbot15">Dedicated Team</h4>
                      <p>
                        A committed team of experts focused on delivering
                        excellence in every project.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-md-6  ">
                  <div class="row mbot40">
                    <div class="col-lg-3 col-md-4 col-sm-2 col-xs-4">
                      <img
                        src="/img/delivery_time.png"
                        alt="quality assurance"
                      />
                    </div>
                    <div class="col-lg-9 col-md-8 col-sm-10 col-xs-8">
                      <h4 class="letter_space_0 mbot15">Delivery on Time</h4>
                      <p>
                        {" "}
                        We prioritize punctuality, ensuring your projects are
                        delivered as scheduled.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-md-6  ">
                  <div class="row mbot40">
                    <div class="col-lg-3 col-md-4 col-sm-2 col-xs-4">
                      <img
                        src="/img/update_technology.png"
                        alt="quality assurance"
                      />
                    </div>
                    <div class="col-lg-9 col-md-8 col-sm-10 col-xs-8">
                      <h4 class="letter_space_0 mbot15">Updated Technology</h4>
                      <p>
                        We leverage the latest technology to provide innovative
                        solutions that meet your requirements.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-md-6  ">
                  <div class="row mbot40">
                    <div class="col-lg-3 col-md-4 col-sm-2 col-xs-4">
                      <img
                        src="/img/quality_assurance.png"
                        alt="quality assurance"
                      />
                    </div>
                    <div class="col-lg-9 col-md-8 col-sm-10 col-xs-8">
                      <h4 class="letter_space_0 mbot15">Quality Assurance</h4>
                      <p>
                        {" "}
                        Stringent quality checks to ensure that our products and
                        services meet the highest standards.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="full_wrapper second_variation_services padtb_96_47">
        <div class="container">
          <h3 class="fnt_white_color">What We Offer</h3>
          <div class="row mbot15">
            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 mbot30 enitre_mouse">
              <div class="shadow_effect effect-apollo mbot25">
                <a href="/services">
                  <img
                    src="img/material_img.jpg"
                    alt="Material"
                    class="img-responsive offerimg"
                  />
                </a>
              </div>

              <h4 class="mbot10">
                <a href="PLC" class="ser_white_head">
                  Automation Solutions
                </a>
              </h4>
              <p class="mbot12 line_he2 p_gray_color">
                We provide end-to-end automation solutions designed to optimize
                your production processes, enhance efficiency, and reduce
                operational costs. Our expertise includes custom-built
                end-of-line systems, automated material handling, packaging
                solutions, and robotic integration. Whether you need a simple
                automated solution or a complex, fully integrated system, we
                tailor our services to meet your specific requirements, ensuring
                seamless integration with your existing setup.
              </p>
              <a href="PLC" class="read_more service_read">
                Read More
              </a>
            </div>

            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 mbot30 enitre_mouse">
              <div class="shadow_effect effect-apollo mbot25">
                <a href="EOL-test-hardware-setup">
                  <img
                    src="img/agriculture_img.jpg"
                    alt="Material"
                    class="img-responsive offerimg"
                  />
                </a>
              </div>

              <h4 class="mbot10">
                <a href="EOL-test-hardware-setup" class="ser_white_head">
                  End-of-Line Systems
                </a>
              </h4>
              <p class="mbot12 line_he2 p_gray_color">
                Our end-of-line systems are engineered to handle the final
                stages of your production process efficiently. From packaging
                and palletizing to quality inspection and product labeling, we
                ensure that your products are ready for distribution. We employ
                the latest technology to create systems that are reliable,
                flexible, and scalable, capable of adapting to changing
                production needs and maintaining high throughput rates.
              </p>
              <a href="EOL-test-hardware-setup" class="read_more service_read">
                Read More
              </a>
            </div>

            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 mbot30 enitre_mouse">
              <div class="shadow_effect effect-apollo mbot25">
                <a href="#">
                  <img
                    src="img/oil_lubricant_img.jpg"
                    alt="Material"
                    class="img-responsive offerimg"
                  />
                </a>
              </div>

              <h4 class="mbot10">
                <a href="DLM5000" class="ser_white_head">
                  Test & Measurement Instruments
                </a>
              </h4>
              <p class="mbot12 line_he2 p_gray_color">
                We offer a wide range of high-precision test and measurement
                instruments designed to meet the needs of various industries,
                including electronics, automotive, and aerospace. Our product
                line includes multi meters, oscilloscopes, spectrum analyzers,
                and environmental testers. Each instrument is selected for its
                accuracy, reliability, and compliance with industry standards,
                ensuring you get the best results for your testing and
                validation processes.
              </p>
              <a href="DLM5000" class="read_more service_read">
                Read More
              </a>
            </div>
          </div>

          <div class="row mbot15">
            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 mbot30 enitre_mouse">
              <div class="shadow_effect effect-apollo mbot25">
                <a href="/services">
                  <img
                    src="img/reserch.png"
                    alt="Material"
                    class="img-responsive offerimg"
                  />
                </a>
              </div>

              <h4 class="mbot10">
                <a href="humidity-stability-chamber" class="ser_white_head">
                  Research, Laboratory, Food, and Pharma Equipment
                </a>
              </h4>
              <p class="mbot12 line_he2 p_gray_color">
                We supply state-of-the-art equipment for research laboratories
                and industries such as food processing and pharmaceuticals. Our
                offerings include laboratory instruments, chemical analyzers,
                sterilization units, and cleanroom solutions. Each piece of
                equipment is designed to meet stringent industry regulations and
                ensure the highest level of precision and safety in research and
                production environments.
              </p>
              <a href="humidity-stability-chamber" class="read_more service_read">
                Read More
              </a>
            </div>

            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 mbot30 enitre_mouse">
              <div class="shadow_effect effect-apollo mbot25">
                <a href="#">
                  <img
                    src="img/eolLab.jpg"
                    alt="Material"
                    class="img-responsive offerimg"
                  />
                </a>
              </div>

              <h4 class="mbot10">
                <a href="antistatic-workbench" class="ser_white_head">
                  ESD Lab Setup
                </a>
              </h4>
              <p class="mbot12 line_he2 p_gray_color">
                We specialize in designing and setting up ESD (Electrostatic
                Discharge) labs that protect sensitive electronic components
                from electrostatic damage. Our solutions include ESD-safe
                workstations, flooring, grounding systems, and monitoring
                equipment. We customize each lab setup to meet your specific
                needs and compliance requirements, ensuring a safe and
                controlled environment for handling electronic devices.
              </p>
              <a href="antistatic-workbench" class="read_more service_read">
                Read More
              </a>
            </div>

            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 mbot30 enitre_mouse">
              <div class="shadow_effect effect-apollo mbot25">
                <a href="#">
                  <img
                    src="img/testpcb.png"
                    alt="Material"
                    class="img-responsive offerimg"
                  />
                </a>
              </div>

              <h4 class="mbot10">
                <a href="#" class="ser_white_head">
                  PCB & Embedded Systems
                </a>
              </h4>
              <p class="mbot12 line_he2 p_gray_color">
                We provide comprehensive PCB design and embedded system
                development services. Our team of experts can handle everything
                from schematic design and PCB layout to firmware development and
                system integration. We cater to a variety of applications,
                including IoT devices, industrial automation, and consumer
                electronics, delivering solutions that are optimized for
                performance, reliability, and cost-effectiveness. Each of these
                services is backed by our commitment to quality, innovation, and
                customer satisfaction.
              </p>
              <a href="" class="read_more service_read">
                Read More
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* -----------accordion---------------- */}
      <div class="full_wrapper padtb_95_100 graybg_color1">
        <div class="container">
          <div class="row">
            <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12 prht_zero">
              <div class="prht85">
                <h3 class="fnt_dark_color_s">Our Core Values</h3>
                <div class="accordion-first clearfix">
                  <div id="accordion2" class="accordion">
                    <div class="accordion-group">
                      <div class="accordion-heading var2_accordian ">
                        <a
                          data-toggle="collapse"
                          data-parent="#accordion1"
                          href="#collapse2"
                          class="accordion-toggle "
                        >
                          <em class="icon-fixed-width fa  fa-plus "></em>Company
                          Milestones
                        </a>
                      </div>
                      <div
                        id="collapse2"
                        style={{ height: "0px" }}
                        class="accordion-body collapse "
                      >
                        <div class="accordion-inner">
                          <span class="wdt_img core_img fl">
                            <img src="/img/milestone1.jpg" alt="core1" />
                          </span>
                          <div class="core_txt fl">
                            <h5 class="fnt_18 mbot10">
                              2021: Establishing a Foundation in Test &
                              Measurement Instruments
                            </h5>
                            <p>
                              Technociv Technologies Pvt. Ltd. was founded with
                              a mission to deliver high-precision test and
                              measurement instruments. Our initial offerings
                              included a diverse range of products such as
                              multimeters, oscilloscopes, spectrum analyzers,
                              and environmental testers. These tools, tailored
                              for industries like electronics, automotive, and
                              aerospace, positioned us as a trusted partner for
                              rigorous testing and validation needs.
                            </p>
                          </div>
                        </div>

                        <div class="accordion-inner">
                          <span class="wdt_img core_img fl">
                            <img src="/img/milestone2.png" alt="core1" />
                          </span>
                          <div class="core_txt fl">
                            <h5 class="fnt_18 mbot10">
                              2022: Expansion into Automation and Laboratory
                              Equipment
                            </h5>
                            <p>
                              Building on our initial success, we expanded our
                              portfolio in 2022 to include comprehensive
                              automation solutions and advanced laboratory
                              equipment. Our offerings grew to encompass
                              custom-built end-of-line systems, automated
                              material handling solutions, advanced packaging
                              systems, and robotic integration, catering to
                              industries seeking to enhance production
                              efficiency. Additionally, we introduced
                              sophisticated laboratory instruments, chemical
                              analyzers, sterilization units, and cleanroom
                              solutions, meeting the demands of research
                              laboratories as well as the food processing and
                              pharmaceutical sectors.
                            </p>
                          </div>
                        </div>

                        <div class="accordion-inner">
                          <span class="wdt_img core_img fl">
                            <img src="/img/milestone3.jpg" alt="core1" />
                          </span>
                          <div class="core_txt fl">
                            <h5 class="fnt_18 mbot10">
                              2022: Diversification into ESD Lab Setup and PCB &
                              Embedded Systems
                            </h5>
                            <p>
                              To further support the electronics industry, we
                              specialized in designing ESD (Electrostatic
                              Discharge) labs, offering ESD-safe workstations,
                              flooring, grounding systems, and monitoring
                              equipment. We also expanded our capabilities into
                              PCB design and embedded systems development,
                              covering everything from schematic design and PCB
                              layout to firmware development and system
                              integration. Our solutions addressed diverse
                              applications, including IoT devices, industrial
                              automation, and consumer electronics, ensuring
                              high performance, reliability, and
                              cost-effectiveness.
                            </p>
                          </div>
                        </div>
                        <div class="accordion-inner">
                          <span class="wdt_img core_img fl">
                            <img src="/img/milestone4.jpg" alt="core1" />
                          </span>
                          <div class="core_txt fl">
                            <h5 class="fnt_18 mbot10">
                              2023: Entry into End-of-Line Systems and
                              Industry-Specific Solutions
                            </h5>
                            <p>
                              In 2023, we reinforced our position in the
                              automation sector by introducing specialized
                              end-of-line systems designed to optimize the final
                              stages of production. These systems cover
                              packaging, palletizing, quality inspection, and
                              product labeling, ensuring reliability,
                              flexibility, and scalability to adapt to varying
                              production demands while maintaining high
                              throughput and consistent quality. This expansion
                              allowed us to deliver comprehensive quality
                              assurance and compliance solutions across various
                              sectors, further enhancing our reputation as a
                              versatile and dependable partner.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-group">
                      <div class="accordion-heading var2_accordian ">
                        <a
                          data-toggle="collapse"
                          data-parent="#accordion1"
                          href="#collapse1"
                          class="accordion-toggle active"
                        >
                          <em class="icon-fixed-width fa fa-minus fa-plus "></em>
                          Our Mission
                        </a>
                      </div>
                      <div
                        id="collapse1"
                        style={{ height: "0px" }}
                        class="accordion-body collapse in"
                      >
                        <div class="accordion-inner">
                          <span class="wdt_img core_img fl">
                            <img src="/img/ourmission.jpg" alt="core1" />
                          </span>
                          <div class="core_txt fl">
                            <h5 class="fnt_18 mbot10">
                              At Technociv Technologies, we strive to:
                            </h5>
                            <p class="line_he3 ">
                              <ol>
                                <li>
                                  {" "}
                                  Offer Innovative Solutions: Continuously
                                  improve and expand our product portfolio to
                                  meet the evolving needs of our clients.
                                </li>
                                <li>
                                  Ensure Quality and Reliability: Provide
                                  high-quality, reliable testing and measurement
                                  equipment that our customers can depend on.
                                </li>
                                <li>
                                  Support Customer Success: Offer exceptional
                                  customer support and services to help our
                                  clients achieve their goals.
                                </li>
                              </ol>
                            </p>
                            {/* <ul class="core_list">
                                                            <li><a href="#">Adipis civelit </a></li>
                                                            <li><a href="#">Adipis civelit </a></li>
                                                        </ul> */}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-group">
                      <div class="accordion-heading var2_accordian ">
                        <a
                          data-toggle="collapse"
                          data-parent="#accordion1"
                          href="#collapse3"
                          class="accordion-toggle "
                        >
                          <em class="icon-fixed-width fa  fa-plus "></em>Key
                          Highlights
                        </a>
                      </div>
                      <div
                        id="collapse3"
                        style={{ height: "0px" }}
                        class="accordion-body collapse "
                      >
                        <div class="accordion-inner">
                          <span class="wdt_img core_img fl">
                            <img src="/img/keyhight1.jpg" alt="core1" />
                          </span>
                          <div class="core_txt fl">
                            <h5 class="fnt_18 mbot10">
                              Expertise in Automotive Solutions
                            </h5>
                            <p class="line_he3 ">
                              • <b>Advanced Automated Solutions:</b> Tailored
                              specifically for the automotive industry to
                              enhance efficiency and reliability.<br></br>•{" "}
                              <b>Sophisticated Test Systems: </b> Focus on
                              critical components including DC-DC converters,
                              battery chargers, and motor controller units.
                            </p>
                         
                          </div>
                        </div>

                        <div class="accordion-inner">
                          <span class="wdt_img core_img fl">
                            <img src="/img/keyhight2.jpg" alt="core1" />
                          </span>
                          <div class="core_txt fl">
                            <h5 class="fnt_18 mbot10">
                            Proficiency in Software Development
                            </h5>
                            <p class="line_he3 ">
                              • <b>Proficiency in Software Development</b>  Skilled in developing precise and efficient testing processes using NI LabVIEW.<br></br>•{" "}
                              <b>Advanced Automation Techniques: </b>  Implementation of techniques that boost the reliability and performance of automotive components.
                            </p>
                         
                          </div>
                        </div>

                        <div class="accordion-inner">
                          <span class="wdt_img core_img fl">
                            <img src="/img/keyhighlight3.jpg" alt="core1" />
                          </span>
                          <div class="core_txt fl">
                            <h5 class="fnt_18 mbot10">
                            Compliance and Quality Assurance
                            </h5>
                            <p class="line_he3 ">
                              • <b>Stringent Industry Standards: </b> Solutions designed to meet rigorous automotive industry standards.<br></br>•{" "}
                              <b>Comprehensive Testing Capabilities:  </b> Ensure optimal functioning and durability of essential automotive systems.
                            </p>
                         
                          </div>
                        </div>

                        <div class="accordion-inner">
                          <span class="wdt_img core_img fl">
                            <img src="/img/keyhighlight4.png" alt="core1" />
                          </span>
                          <div class="core_txt fl">
                            <h5 class="fnt_18 mbot10">
                            Tailored Testing Solutions
                            </h5>
                            <p class="line_he3 ">
                              • <b>Diverse Testing Applications: </b> Capabilities include testing for power conversion, battery management, and motor control.<br></br>•{" "}
                              <b>Accurate and Dependable Results:  </b>Delivering consistent results that meet the unique needs of each client.
                            </p>
                         
                          </div>
                        </div>

                        <div class="accordion-inner">
                          <span class="wdt_img core_img fl">
                            <img src="/img/keyhighlight5.jpg" alt="core1" />
                          </span>
                          <div class="core_txt fl">
                            <h5 class="fnt_18 mbot10">
                            Expertise in Electronics and Electrical Solutions
                            </h5>
                            <p class="line_he3">
                              • <b>Comprehensive Testing Systems:  </b>Development of advanced testing solutions for electronic components, including circuit boards, sensors, and communication devices.<br></br>•{" "}
                              <b>Precision Instruments:  </b>Providing high-precision test and measurement instruments for various electronic applications, ensuring accuracy and compliance with industry standards.
                            </p>
                         
                          </div>
                        </div>

                        <div class="accordion-inner">
                          <span class="wdt_img core_img fl">
                            <img src="/img/keyhighlight6.jpg" alt="core1" />
                          </span>
                          <div class="core_txt fl">
                            <h5 class="fnt_18 mbot10">
                            Specialized Solutions
                            </h5>
                            <p class="line_he3 ">
                              • <b>PCB Testing and Validation:  </b>Robust testing solutions for PCB design and embedded systems to ensure functionality and reliability.<br></br>•{" "}
                              <b>Electrostatic Discharge (ESD) Protection:</b>Custom setups for ESD labs, safeguarding sensitive electronic components during testing and handling.
                            </p>
                         
                          </div>
                        </div>

                        <div class="accordion-inner">
                          <span class="wdt_img core_img fl">
                            <img src="/img/keyhighlight7.jpg" alt="core1" />
                          </span>
                          <div class="core_txt fl">
                            <h5 class="fnt_18 mbot10">
                            Commitment to Excellence
                            </h5>
                            <p class="line_he3 ">
                              • <b>Innovative Test Solutions: </b>Providing cutting-edge automated testing systems for both automotive and electronics sectors.<br></br>•{" "}
                              <b>Focus on Client Needs: </b>Customized solutions that enable superior performance and reliability in automotive and electronic products.
                            </p>
                         
                          </div>
                        </div>


                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12 pad_zero col_margin">
              <h3 class="fnt_dark_color_s">About Us</h3>
              <div class="variation2_about_img full_width mbot35 aboutDivhome">
                <span class="first_img">
                  <img src="/img/about_img1.jpg" alt="image" />
                </span>
              </div>
              <p className="">
                Technociv Technologies was founded by a dedicated group of
                engineers with a vision to provide top-tier testing and
                measurement solutions across various industries. Our founders,
                coming from diverse technical backgrounds, brought together
                their expertise to create a company that prioritizes innovation,
                quality, and customer satisfaction. From our early days, we
                focused on delivering reliable and efficient test and
                measurement equipment to the electronics and construction
                sectors. Our commitment to excellence quickly garnered the trust
                of clients, enabling us to expand our product offerings and
                customer base. Over the years, we have partnered with
                world-renowned brands such as Yokogawa, Hikvision, Fluke, Rohde
                & Schwarz, Keysight, and Laplace, establishing ourselves as a
                leading distributor in Northern India.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cards;
